import React from 'react';
import GeckoFieldBase from '../_base.jsx';
import Select from 'react-select-plus'; // https://github.com/HubSpot/react-select-plus

class GeckoFieldSelect extends GeckoFieldBase {
  handleChange(option) {
    return this.props.handler.bind(
      this,
      this.field().key,
      this.prepareValue(option)
    )();
  }

  prepareValue(option) {
    return option && option.value ? option.value : null;
  }

  render() {
    const inputProps = Object.assign(
      { autoComplete: 'off' },
      this.config().inputProps || {}
    );

    return (
      <Select
        id={this.renderId()}
        className="gecko-ui-material"
        value={this.value()}
        options={this.options()}
        optionRenderer={this.props.field.optionRenderer}
        valueRenderer={this.props.field.valueRenderer}
        onChange={this.handleChange.bind(this)}
        disabled={this.isDisabled()}
        placeholder={this.field().placeholder}
        inputProps={inputProps}
        {...this.config()}
      />
    );
  }
}

export default GeckoFieldSelect;
